import React from 'react'
import "./locations.css";
import { Location } from '../data/Data';
function locations() {
    return (
        <section className='paddings flexDisplay'>
            <h1 className='primaryText'>Explore By Location</h1>
            <p className='secondaryText'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <br/> incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
            
            <div className="locationContainer">
                {Location.map((item,index)=>(
                    <div className='onlyLocation' style={{ background: `url(${item.cover})`, backgroundSize: "cover", backgroundPosition: "center" }}>
                        <div className="childrenLocal">
                            <h1 className='text-white xl:text-xl text-base'>{item.name}</h1>
                            <div className="detailsChill">
                                <span className="secondaryText">{item.Villas}</span>
                                <span className="secondaryText">{item.Offices}</span>
                                <span className="secondaryText">{item.Apartments}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            </p>
        </section>
    )
}

export default locations
